import React, { type JSX } from 'react'

import { SimpleLayout } from 'layouts/SimpleLayout'
import 'styled-components'

type BoxFormLayoutProps = {
  children: React.ReactNode
}

export const BoxFormLayout = React.memo(({ children }: BoxFormLayoutProps): JSX.Element => {
  return (
    <SimpleLayout>
      <div
        css={`
          padding: 12px;
          width: 100%;
          max-width: 512px;
        `}
      >
        <div
          css={`
            width: 100%;
          `}
        >
          {children}
        </div>
      </div>
    </SimpleLayout>
  )
})
